import React from "react";

const CameraIcon = () => {
  return (
    <svg
      id="ProfileIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 64 64"
    >
      <g
        id="Rectangle_4"
        data-name="Rectangle 4"
        fill="#9cd8ca"
        stroke="#707070"
        stroke-width="1"
      >
        <rect width="64" height="64" rx="32" stroke="none" />
        <rect x="0.5" y="0.5" width="63" height="63" rx="31.5" fill="none" />
      </g>
      <path
        id="Icon_material-edit"
        data-name="Icon material-edit"
        d="M4.5,29.831V36.5h6.666L30.825,16.837l-6.666-6.666ZM35.98,11.682a1.77,1.77,0,0,0,0-2.506L31.821,5.016a1.77,1.77,0,0,0-2.506,0L26.061,8.269l6.666,6.666Z"
        transform="translate(11.5 11.504)"
      />
    </svg>
  );
};

export default CameraIcon;
